import React from 'react'
import { Modal } from 'react-bootstrap'

interface UnicodeModalProps {
  show: boolean
  onHide: () => void
  message: string
}

const getUnicodeCharacters = (str: string) => {
  if (!str) return []
  const GSM_7BIT_CHARS =
    "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?" +
    "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà"
  const isGSM = (char: string) => GSM_7BIT_CHARS.includes(char)
  const unicodeChars: string[] = []
  for (let i = 0; i < str.length; i++) {
    if (!isGSM(str[i])) {
      unicodeChars.push(str[i])
    }
  }
  return unicodeChars
}

const getUniqueUnicodeCharacters = (str: string) => {
  if (!str) return []
  const GSM_7BIT_CHARS =
    "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?" +
    "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà"
  const isGSM = (char: string) => GSM_7BIT_CHARS.includes(char)
  const unicodeChars: string[] = []
  for (let i = 0; i < str.length; i++) {
    if (!isGSM(str[i]) && !unicodeChars.includes(str[i])) {
      unicodeChars.push(str[i])
    }
  }
  return unicodeChars
}

const UnicodeModal: React.FC<UnicodeModalProps> = ({ show, onHide, message }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #e9ecef' }}>
        <div>
          <Modal.Title style={{ color: '#2d3436', fontSize: '20px', fontWeight: '600', marginBottom: '4px' }}>
            Unicode Characters Detected
          </Modal.Title>
          <p style={{ color: '#f1416c', margin: 0, fontSize: '14px', fontWeight: '500' }}>
            <span
              style={{
                backgroundColor: '#f1416c',
                color: '#ffffff',
                borderRadius: '6px',
                fontWeight: '700',
                fontSize: '13px',
                border: '2px solid #d63031',
                display: 'inline-block',
                minWidth: '24px',
                textAlign: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              {getUnicodeCharacters(message).length}
            </span> characters found - See highlighted below
          </p>
        </div>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
        <div className="mb-4">
          <h6 style={{ color: '#2d3436', marginBottom: '12px', fontWeight: '600' }}>
            Your Message Preview:
          </h6>
          <div
            className="p-3 border rounded-3"
            style={{
              backgroundColor: '#ffffff',
              fontFamily: 'Consolas, Monaco, "Courier New", monospace',
              fontSize: '14px',
              lineHeight: '1.6',
              maxHeight: '300px',
              overflowY: 'auto',
              wordBreak: 'break-word',
              whiteSpace: 'pre-wrap',
              border: '2px solid #e9ecef',
              boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)',
            }}
          >
            {message?.split('').map((char: string, index: number) => {
              const isUnicodeChar = getUniqueUnicodeCharacters(message).includes(char)
              return (
                <span
                  key={index}
                  style={{
                    color: isUnicodeChar ? '#ffffff' : '#2d3436',
                    backgroundColor: isUnicodeChar ? '#f1416c' : 'transparent',
                    border: isUnicodeChar ? '1px solid #d63031' : 'none',
                    borderRadius: isUnicodeChar ? '4px' : '0',
                    padding: isUnicodeChar ? '2px 6px' : '0',
                    fontWeight: isUnicodeChar ? '600' : 'normal',
                    boxShadow: isUnicodeChar ? '0 1px 3px rgba(0,0,0,0.2)' : 'none',
                  }}
                >
                  {char}
                </span>
              )
            })}
          </div>
        </div>

        <div
          className="alert alert-warning"
          style={{
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeaa7',
            borderRadius: '8px',
            padding: '16px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <i
              className='fas fa-exclamation-triangle'
              style={{ color: '#f1416c', fontSize: '18px', marginRight: '12px' }}
            ></i>
            <div>
              <strong style={{ color: '#e67e22' }}>Important:</strong>
              <p style={{ margin: '4px 0 0 0', color: '#8b4513', fontSize: '14px' }}>
                Unicode characters require UCS-2 encoding, which reduces the SMS character limit from 160 to 70 characters per message and may increase costs.
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default UnicodeModal
